import React, { useEffect, useState, useRef } from "react";
import * as axiosInstance from '../utils/axiosinstace';
import { getUserName, getRole } from '../utils/common';
import { Role } from '../utils/role';
import { useForm } from "react-hook-form";
import { Tabs, Tab } from 'react-bootstrap-tabs';
import { useLoading, Bars } from '@agney/react-loading';
import TestDevice from "./TestDevice";
import { useTranslation } from 'react-i18next';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
const SensorCalibration = () => {
  const { t } = useTranslation(['device', 'common']);
    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues: {
            type: 'ammonia' // Set default value for the sensor type
        }
    });
    const { register: register2, handleSubmit: handleSubmit2,
        watch: watch2, formState: { errors: errors2 } } = useForm({
            mode: 'onChange'
        });
    const [showLoader, setShowloader] = useState(false);
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <Bars width="30" color="#333" />,
    });
    const [farmers, setFarmers] = useState([]);
    const getFarmersList = async () => {
        try {
            const response = await axiosInstance.getListofFarmers_admin()
            setFarmers(response.list)
        } catch (err) {
            console.log(err.message);
        }
    }
    const [devices, setDevices] = useState([]);
    const getDevicesList = async (farmerID) => {
        try {
            const response = await axiosInstance.getDevices(farmerID)
            JSON.stringify(response);
            setDevices(response.list);
            setShowResults(false);
            setSensorData({})
        } catch (err) {
            console.log(err.message);
        }
    }
    const [showResults, setShowResults] = useState(false)
    const [resultMessage, setResultMessage] = useState({});
    const onDevicetest = async (data, e) => {
        alert(JSON.stringify(data))
    }
   
    const [sensorData, setSensorData] = useState({

    });
    // const [sensorStatus, setSensorStatus] = useState(false);
    const onSubmit = async (data, e) => {
        e.preventDefault();
        //alert(JSON.stringify(data))
        setShowloader(true);
        try {
            //setSelectedType(data.type)
            // alert(JSON.stringify(data))
            const response = await axiosInstance.callibrations(data)

            setShowloader(false);
            setShowResults(true);
            setResultMessage({
                error: !response.status, message: response.message
            });
            if (response.data != undefined) {
                setSensorData(response.data)
            }
            e.target.reset();
        } catch (err) {
            console.log(err)
            setShowloader(false)
            setShowResults(true)
            setResultMessage({
                error: true, message: err.response.data.message
            });
            //console.log(err.response.data.message);
        }
    }
    const onFarmerChange = (e) => {
        getDevicesList(e.target.value);
        setShowResults(false);
        setSensorData({})

    }
    const [showValues, setShowValues] = useState(false);
    const selectedType = watch('type', 'ammonia');
    useEffect(() => {
        getFarmersList();
        if (getRole() == Role.Farmer) {
            getDevicesList('any');
        }
        //alert(selectedType)
    }, [selectedType]);
    return (
        <div className="batchOperations">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('device:calib.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div class="card-body">
                    <Tabs activeHeaderStyle={{ background: 'transparent' }}>
                        <Tab label={t('device:calib.calibration')}>
                            <div className="row">
                                <div className="col-md-5">
                                    <form onSubmit={handleSubmit(onSubmit)}>

                                        {/* <div className="spacer"></div> */}
                                        {getRole() === Role.Admin ?

                                            <div className="form-group">
                                                <label>{t('common:select.farmer')}</label>
                                                <select class="form-control" name="farmer"
                                                    {...register("farmerID", {
                                                        required: t('forms:select.farmer'),
                                                        onChange: (e) => { onFarmerChange(e) }
                                                    })}
                                                >
                                                    <option value="">{t('common:select.dashed')}</option>
                                                    {farmers.map(item => (
                                                        <option
                                                            key={item.id}
                                                            value={item.id}
                                                        >
                                                            {item.farmerName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.farmerID && <span className="err-msg">{errors.farmerID.message}</span>}
                                            </div>

                                            : ""}
                                        <div className="form-group">
                                            <label>{t('device:list.selectDevice')}</label>
                                            <select class="form-control" name="device"
                                                {...register('deviceID', { required: t('forms:select.device') })}>

                                                <option value="">{t('common:select.dashed')}</option>
                                                {devices.map(item => (
                                                    <option
                                                        key={item.imeiNumber}
                                                        value={item.imeiNumber}
                                                    >
                                                        {item.imeiNumber}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.deviceID && <span className="err-msg">{errors.deviceID.message}</span>}
                                        </div>
                                        <div className="spacer"></div>
                                        <div class="form-group clearfix">
                                            <div class="form-group clearfix">
                                                <div class="icheck-primary d-inline">
                                                    <input
                                                        type="radio"
                                                        id="radioPrimary1"
                                                        name="type"
                                                        value="ammonia"
                                                       // onChange={handleSensorTypeChange}
                                                        //checked={selectedType === 'ammonia'}
                                                        {...register('type', { required: t('forms:select.sensor') })}
                                                    />
                                                    <label for="radioPrimary1">
                                                        Ammonia &nbsp;  &nbsp;  &nbsp;
                                                    </label>
                                                </div>
                                                <div class="icheck-primary d-inline">
                                                    <input
                                                        type="radio"
                                                        id="radioPrimary2"
                                                        name="type"
                                                        value="co2"
                                                        //onChange={handleSensorTypeChange}
                                                        //checked={selectedType === 'co2'}
                                                        {...register('type', { required: t('forms:select.sensor') })}
                                                    />
                                                    <label for="radioPrimary2">
                                                        {t('device:calib.carbonDioxide')}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div>{errors.type && <span className="err-msg">{errors.type.message}</span>}</div>
                                        <div className="spacer"></div>
                                        <div className="row">
                                            <div className="col-md-6 form-group">
                                                <input style={{ width: '100%' }}
                                                    disabled={showLoader}
                                                    type="submit" value="Calibrate" class="btn btn-primary" />
                                            </div>
                                            <div className="col-md-6">
                                                {showLoader ?
                                                    <div>
                                                        <section  {...containerProps} style={{ "margin-top": "0px", color: '#ccc', float: 'left' }}>
                                                            {indicatorEl}
                                                        </section>
                                                        <p>&nbsp; {t('device:calib.doNotRefresh')}</p>
                                                        {/* <div style={{ float: 'left' }}>
                                                            <p>{t('device:calib.reasonsIntro')}</p>
                                                            <ul>
                                                                <li>{t('device:calib.reasonOff')}</li>
                                                                <li>{t('device:calib.reasonSensor')}</li>
                                                                <li>{t('device:calib.reasonNetwork')}</li>
                                                            </ul>
                                                        </div> */}
                                                    </div>
                                                    : ""
                                                }
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                {showResults ? <Results key={Math.random()} message={resultMessage.message} error={resultMessage.error} /> : null}
                                            </div>
                                            {
                                                resultMessage?.error ?
                                                    <div>
                                                        <p>{t('device:calib.reasonsIntro')}</p>
                                                        <ul>
                                                            <li>{t('device:calib.reasonOff')}</li>
                                                            <li>{t('device:calib.reasonSensor')}</li>
                                                            <li>{t('device:calib.reasonNetwork')}</li>
                                                        </ul>
                                                    </div>
                                                    :
                                                    <></>
                                            }

                                        </div>
                                        {
                                            Object.keys(sensorData).length > 0 && selectedType == 'ammonia' ?
                                                <div className="row">
                                                    <div className="col-md-12">

                                                        <ul>
                                                            <li><strong>{t('device:calib.time')}</strong> {sensorData.TimeStamp}</li>
                                                            <li><strong>{t('device:calib.vrl')} </strong> {sensorData.VRL} </li>
                                                            <li><strong>{t('device:calib.rs')} </strong>{sensorData.RS}</li>
                                                            <li><strong>{t('device:calib.ro')} </strong>{sensorData.CO2} RO</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                : <></>
                                        }

                                    </form>
                                </div>
                                {
                                    selectedType=='ammonia'?

                                
                                <div className="col-md-7">
                                    <h3 style={{ textTransform: 'none' }}>{t('device:calib.infoAmmonia')}</h3>
                                    <Accordion>
                                        <AccordionItem>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    {t('device:calib.whatIsCalibration')}
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <p>
                                                    {t('device:calib.calibrationExplain')}
                                                </p>
                                                <p>For example 1.0 Volts = 100 ppm, 1.1 volts = 120 ppm and so on (values for illustrative purposes only).</p>
                                                <p>{t('device:calib.whyCalibrate')}</p>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                        <AccordionItem>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    {t('device:calib.whenCalibrateAmmonia')}
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <p>
                                                    {t('device:calib.whenAmmoniaAnswer')}
                                                </p>
                                                <p>{t('device:calib.calibrateAsFit')}</p>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                        <AccordionItem>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    {t('device:calib.howCalibrateAmmonia')}
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <p><strong>{t('device:calib.step1')}</strong> In case of new sensor or sensor that has not been operating for a long period of time (over 1 month), leave the sensor turned on for AT LEAST 36 hours in an Ammonia free environment.</p>
                                                <p>{t('device:calib.ammoniaContinuousUse')}</p>
                                                <p><strong>{t('device:calib.step2')}</strong> Select the device (IMEI number) from the list, to which the Sensor is connected. </p>
                                                <p><strong>{t('device:calib.step3')}</strong> {t('device:calib.clickOn')} <span style={{color: 'blue'}}>{t('device:calib.calibrate')}</span> button. </p>
                                                <p><strong>{t('device:calib.step4')}</strong> {t('device:calib.waitAndClose')}</p>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>

                                </div>
                                :<></>}
                                {
                                    selectedType == 'co2'?
                                    <div className="col-md-7">
                                    <h3 style={{ textTransform: 'none' }}>{t('device:calib.infoCo2')}</h3>
                                    <Accordion>
                                        <AccordionItem>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    {t('device:calib.whatIsCalibration')}
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <p>
                                                    {t('device:calib.calibrationExplain')}
                                                </p>
                                                <p>For example 1.0 Volts = 100 ppm, 1.1 volts = 120 ppm and so on (values for illustrative purposes only).</p>
                                                <p>{t('device:calib.whyCalibrate')}</p>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                        <AccordionItem>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    {t('device:calib.whenCalibrateCo2')}
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <p>
                                                {t('device:calib.whenCo2Answer')}

                                                </p>
                                                
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                        <AccordionItem>
                                            <AccordionItemHeading>
                                                <AccordionItemButton>
                                                    {t('device:calib.howCalibrateAmmonia')}
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel>
                                                <p><strong>{t('device:calib.step1')}</strong> {t('device:calib.co2Placement')}</p>
                                                <p style={{fontStyle: 'italic'}}>{t('device:calib.co2PlacementExamples')}
</p>
                                                <p>{t('device:calib.note')} <strong>{t('device:calib.doNot')}</strong> {t('device:calib.co2Avoid')}
</p>
                                                <p><strong>{t('device:calib.step2')}</strong> Select the device (IMEI number) from the list, to which the Sensor is connected. </p>
                                                <p><strong>{t('device:calib.step3')}</strong> {t('device:calib.clickOn')} <span style={{color: 'blue'}}>{t('device:calib.calibrate')}</span> button. </p>
                                                <p><strong>{t('device:calib.step4')}</strong> {t('device:calib.waitAndClose')}</p>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </Accordion>

                                </div>
                                :<></>}
                            </div>
                        </Tab>
                        {
                            getRole() == Role.Admin ?
                                <Tab label={t('device:calib.testDevice')}>
                                    <TestDevice></TestDevice>
                                </Tab>
                                : <></>
                        }

                    </Tabs>

                </div>
            </div>
        </div>

    );
}
const Results = (props) => {
    let error, classes;
    if (props.error === false) {
        error = 'Success';
        classes = 'alert alert-success alert-dismissible fade show'
    } else {
        error = 'Error!';
        classes = 'alert alert-danger alert-dismissible fade show'
    }
    return (
        <div className="results">
            <div className={classes}>
                <strong>{error}</strong> {props.message}
                <button type="button" class="close" data-dismiss="alert">&times;</button>
            </div>
        </div>
    );
}
export default SensorCalibration;